import React, { useState } from "react";
import GenericModal from "../../../../components/modal/GenericModal";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import { jsonNoEstaVacio } from "../../../../helper/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RechazarSolicitud = ({ toggleModal, refreshPage, title = "Eliminar", actionLabel = "eliminar", api, item = "item", id = "", name, payload = {}, externalCallback = null }) => {
    const [isSending, setIsSending] = useState(false);
    const [managePost] = useManagePostRequest();
    const [motivoRechazo, setMotivoRechazo] = useState("");
    const handleAction = async () => {
        setIsSending(true);
        const payloadFinal = {
            ...payload,
            motivoRechazo
        };
        try {
            if (jsonNoEstaVacio(payload) && !id) {
                await managePost(api(), payloadFinal, successHandleCallback);
            } else {
                await managePost(api(id), {}, successHandleCallback);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSending(false);
        }
    };

    const successHandleCallback = async () => {
        await refreshPage();
        if (externalCallback) await externalCallback();
        toggleModal();
    }


    return (
        <GenericModal
            titulo="Rechazar"
            showModal={toggleModal}
            width={"600px"}
        >
            <div className="modal-body pt-0 pl-0">
                <div className="container-fluid">
                    <InputTextArea
                        label="Detalle del motivo"
                        value={motivoRechazo}
                        onChange={(e) => setMotivoRechazo(e.target.value)}
                    />
                </div>
            </div>
            <div className="modal-footer justify-content-end">
                <button
                    className="btn btn-primary generic-button-ficha mr-2"
                    disabled={isSending}
                    onClick={handleAction}>
                    No Aprobar {isSending && (<FontAwesomeIcon icon='spinner' transform="left-9" className="spinner ml-3" />)}
                </button>
                <button
                    className="btn btn-primary generic-button-ficha"
                    disabled={isSending}
                    onClick={() => { toggleModal() }}>
                    Cancelar
                </button>
            </div>
        </GenericModal>
    );

}

export default RechazarSolicitud;